module.exports = __webpack_public_path__ + "static/media/detailedHomepage.056e77cb.svg";